export enum acceptanceType {
  NOT_REQUESTED = 'NOT_REQUESTED',
  CANCELLED_REQUEST = 'CANCELLED_REQUEST',
  BETTER_PROPOSAL_BARI = 'BETTER_PROPOSAL_BARI',
}
